import _ from 'lodash';
import { AppointmentEntryRemoteDto } from 'src/generated/signalR/appointment-entry-remote-dto';
import { Enum, EnumType } from 'ts-jenum';

@Enum<AppointmentTypeEnum>('value')
export class AppointmentTypeEnum extends EnumType<AppointmentTypeEnum>() {
   static readonly FROM_TO = new AppointmentTypeEnum('FROM_TO');
   static readonly WHOLE_DAY = new AppointmentTypeEnum('WHOLE_DAY');
   static readonly OPEN_ENDED = new AppointmentTypeEnum('OPEN_ENDED');

   public static fromAppointment(appointment: AppointmentEntryRemoteDto): AppointmentTypeEnum {
      if (_.isNil(appointment)) {
         return AppointmentTypeEnum.FROM_TO;
      }
      if (appointment.end.toLocaleDateString() === '12/31/2050') {
         return AppointmentTypeEnum.OPEN_ENDED;
      }
      // Note: Milliseconds for 23:59:59
      if (appointment.end.valueOf() - appointment.start.valueOf() >= 86399000) {
         return AppointmentTypeEnum.WHOLE_DAY;
      }
      return AppointmentTypeEnum.FROM_TO;
   }

   private constructor(public value: string) {
      super();
   }
}
